import { gql, TypedDocumentNode } from '@common/hooks';
import {
  AssignShiftMutationCgResponse,
  AssignShiftMutationVariables,
} from '@common/graphql';

// Manually assigns a worker to an open slot on a reviewable run (WORK-6384). The slot is
// addressed by the grid's open-row descriptor (week/day/section/role) — the same shape
// drag-to-assign (WORK-6399) reuses, passing `force: true` so a drop bypasses the eligibility
// gate (role still enforced server-side); the panel button omits force → stays eligible-only.
// Returns the inserted shift's uuid so the caller can refetch the recompute-on-read grid /
// candidates / health snapshot.
export const ASSIGN_SHIFT_MUTATION: TypedDocumentNode<
  AssignShiftMutationCgResponse,
  AssignShiftMutationVariables
> = gql`
  mutation AssignShift(
    $balancerRunId: ID!
    $organizationUnitId: ID!
    $weekKey: String!
    $dayKey: String!
    $shiftTypeSection: String!
    $role: String!
    $workerId: ID!
    $force: Boolean
  ) {
    assignShift(
      balancerRunId: $balancerRunId
      organizationUnitId: $organizationUnitId
      weekKey: $weekKey
      dayKey: $dayKey
      shiftTypeSection: $shiftTypeSection
      role: $role
      workerId: $workerId
      force: $force
    ) {
      affectedShiftId
      balancerRunId
      state
    }
  }
`;
